<template>
  <div class="homework-list-wraper">
     <!-- <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        ref="list"
        @load="onLoad"
      > -->
      <ul class="work-list" v-if="homeworkList.length">
        <li class="work-item" 
          :class="index >=0 && index < homeworkList.length -1 && homeworkList.length>1 ? 'border': ''"
          v-for="(item, index) in homeworkList"
          :key="index"
          @click="toDetail(item)"
        >
          <div class="left">
            <span class="title">作业</span>
            <span class="name ellipsis">{{item.name}}</span>
          </div>
          <!-- 0未提交、1已提交未点评、2已提交已点评通过、3已提交已点评未通过 -->
          <div class="right" :class="item.status === 0? 'abnormal':''">{{item.status === 0 ? '未提交': item.status === 1? '已提交': '已点评'}}</div>
        </li>
       

      </ul>
      <div class="no-date" v-else>
        暂无数据
      </div>

    <!-- </van-list> -->
  </div>
</template>

<script>
export default {
  name: 'HomeworkList',
  props: {
    courseId: {
      type: String,
      default: ''
    },
    taskId: {
      // type: String,
      default: ''
    }
  },
  data() {
   return {
      homeworkList: [
        // {name: '啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊',status: 0},
        // {name: '啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊',status: 1},
        // {name: '啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊', status: 2},
        // {name: '啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊', status: 3},

      ],
      pageNum: 0,
      finished: false,
      loading: false
    }
  },
  mounted() {
    const params = {
        courseId: this.courseId || this.$route.query.courseId,
        taskId: this.taskId || this.$route.query.taskId
        // pageNum: this.pageNum,
        // pageSize: 20
      }
      this.findHomeworkListById(params)
  },
  methods: {
    onLoad() {
      this.pageNum = this.pageNum + 1
      const params = {
        courseId: this.courseId || this.$route.query.courseId,
        taskId: this.taskId || this.$route.query.taskId
        // pageNum: this.pageNum,
        // pageSize: 20
      }
      this.findHomeworkListById(params)
    },
    toDetail(info) {
      this.$router.push({
        path: '/homeworkDetail',
        name: 'homeworkDetail',
        query: {
          courseId: this.courseId || this.$route.query.courseId,
          status: info.status?info.status:1,
          homeworkId: info.id,
          taskId: this.taskId
        }
      })
    },
    // 
    async findHomeworkListById(params) {
        let result = await this.$api.zuoye.findHomeworkListById(params)
        console.log(result)
        if(result.success) {
          this.homeworkList = result.data || []
        } 
        // this.loading = false
        // this.finished = result.data.isLastPage
    }
  }
}
</script>

<style lang="stylus" scope>
.ellipsis
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
.homework-list-wraper
  width 100%
  .no-date 
    font-size 30px
    line-height 42px
    text-align center
    color #666666
  .work-list
    width: 690px;
    background: #FFFFFF;
    border-radius: 24px;
    border: 1px solid #D9D9D9;
    margin 0 auto
    box-sizing border-box
    padding 0 35px 0 30px
    .work-item
      width 100%
      height 80px
      box-sizing border-box 
      display flex 
      align-items center 
      justify-content space-between
      &.border 
        border-bottom 1px solid #EAEAEA
      .left 
        display flex
        width 87%
        .title 
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #3760FF;
          border-radius: 4px;
          opacity: 0.7;
          border: 1px solid #3760FF;
          padding 0px 4px
          //   width 48px
          height 26px
          line-height 26px
          text-align center
          margin-right 6px
        .name
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 30px;
          width 86%
      .right 
        // width 16.5%
        flex 1
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #415FF6;
        line-height: 26px;
        &.abnormal
          color #EC5A54
          


</style>